/* eslint-disable no-plusplus */
/* eslint-disable arrow-body-style */
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    companyID: null,
    companyName: null,
    divisionID: null,
    divisionName: null,
  },
  mutations: {
    setCompanyID(state, companyID) {
      state.companyID = companyID;
    },
    setCompanyName(state, companyName) {
      state.companyName = companyName;
    },
    setDivisionID(state, divisionID) {
      state.divisionID = divisionID;
    },
    setDivisionName(state, divisionName) {
      state.divisionName = divisionName;
    },
  },
});



// WEBPACK FOOTER //
// ./src/store.js